templates = require 'app/scripts/views/internal/templates'
View = require 'app/scripts/views/internal/view'
t = require('app/scripts/views/internal/teacup-with-helpers')('select_member')
memberTemplate = require 'app/scripts/views/templates/member'
{ featureFlagClient } = require '@trello/feature-flag-client'

# This template will be used if the remarkable.new-select-member flag is enabled
template = t.renderable (data) ->
  { url, extraText, id, viewTitle, username, isVirtual, fullName, username, inactive, unconfirmed } = data
  t.a '.name.js-select-member', {
    href: url || '#',
    class: t.classify({ 'multi-line': extraText }),
    idMember: id,
    title: viewTitle
    autocompleteText: username
    }, ->

    t.span '.member.js-member', { class: t.classify({ virtual: isVirtual }) }, ->
      memberTemplate data

    t.span '.full-name', { name: "#{ fullName }#{ if username then " (#{ username }" else ""}", 'aria-hidden': true }, ->
      t.text fullName
      t.text ' '
      if username
        t.span ".username", ->
          t.text "(#{username})"

    if extraText
      t.div '.extra-text.quiet', ->
        t.format 'extratext', { extraText }

    t.icon 'check', { class: 'checked-icon', 'aria-label': t.l('added-to-card') }

    t.icon 'forward', { class: 'light option js-open-option' }

    if inactive
      t.span '.quiet.sub-name', ->
        t.format 'inactive-account'

    if unconfirmed
      t.span '.quiet.sub-name', ->
        t.format 'unconfirmed-user'

useNewSelect = -> featureFlagClient.get('remarkable.new-select-member', false)

module.exports = class SelectMemberView extends View
  tagName: ->
    if useNewSelect() then 'li' else 'div'

  className: ->
    if useNewSelect() then 'item js-member-item'
  # options: showUnconfirmed, showInactive, linkName
  initialize: ->

  render: ->
    data = @model.toJSON()

    if @model.get('memberType') == "ghost"
      data.isVirtual = true

    data.unconfirmed = @options.showUnconfirmed && !data.isVirtual && !data.confirmed
    data.inactive = @options.showInactive && !data.active

    data.isKnownMember = @options.isKnownMember
    data.extraText = @options.extraText
    data.disabled = @options.disabled

    if @options.linkName
      data.url = "/#{@model.get('username')}"
    else
      delete data.url

    if useNewSelect()
      @el.innerHTML = template(data)

      @$el
      .toggleClass('active', Boolean(data.isActive))
      .toggleClass('unconfirmed', Boolean(data.unconfirmed))
      .toggleClass('inactive', Boolean(data.inactive))
      .toggleClass('js-autoselect', Boolean(data.isKnownMember))
      .toggleClass('disabled', Boolean(data.disabled))

    else
      @$el[0].innerHTML = templates.fill(
        'select_member',
        data,
        {},
        member: templates.member
      )

    @$('.js-member').data('id', @model.id)

    @
